const environment = process.env.MIX_APP_ENV;
const dsn = process.env.MIX_SENTRY_DSN;

const hasValidEnvironmentFor = {
    reports: () => dsn && dsn !== '' && environment && (environment.match('sandbox') || ['staging', 'production'].includes(environment)),
    warn: () => (!dsn || dsn === '') && environment && (environment === 'staging' || environment.match('sandbox')),
};

export {
    environment,
    dsn,
    hasValidEnvironmentFor
};